import { render, staticRenderFns } from "./EntityStatusDialogsTabLinks.vue?vue&type=template&id=7a8a9468"
import script from "./EntityStatusDialogsTabLinks.vue?vue&type=script&lang=js"
export * from "./EntityStatusDialogsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports